





























import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfInternalProjectSummaryReport",
  components: { AuditTabPane },
})
export default class AuditTabOfInternalProjectSummaryReport extends Vue {
  get fetchData() {
    return api.internalProjectSummaryReports.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "internalProjectSummaryReportsDetail",
      params: {
        id: dto.id,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
